export const getLanguages = (state) => state.cache.languages;
